import { render, staticRenderFns } from "./WasteHandlingSiumlationGraph.vue?vue&type=template&id=13525685&"
import script from "./WasteHandlingSiumlationGraph.vue?vue&type=script&lang=js&"
export * from "./WasteHandlingSiumlationGraph.vue?vue&type=script&lang=js&"
import style0 from "./WasteHandlingSiumlationGraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports